<template>
  <svg width="26" height="31" viewBox="0 0 26 31" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M1.27446 0.774457L15.468 0.774457L24.7255 9.59117V29.7811L1.27446 29.7811V0.774457Z" stroke="#1170B8" stroke-width="1.54891"/>
  </svg>
</template>

<script>
export default {
  name: 'IconFile'
}
</script>
